import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Row, Col } from 'react-bootstrap';

class DisplayDataGrid extends Component {
  constructor() {
    super();
    this.state = {
      data: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };
  }

  componentDidMount() {
    if (this.props.rows) {
      const data = { ...this.state.data, rows: this.props.rows };
      this.setState({ data });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.columns && nextProps.columns !== this.props.columns) {
      this.setState({ columns: nextProps.columns });
    }

    if (nextProps.rows && nextProps.rows !== this.props.rows) {
      const data = { ...this.state.data, rows: nextProps.rows };
      this.setState({ data });
    }
  }

  getRows = () => Data.Selectors.getRows(this.state.data);

  getSize = () => this.getRows().length;

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  }

  // Handle the sortable function
  handleGridSort = (sortColumn, sortDirection) => {
    const data = { ...this.state.data, sortColumn, sortDirection };
    this.setState({ data });
  }

  render() {
    return (
      <Row>
        <Col sm={12}>
          <div id="DisplayDataGrid-dataGrid1">
            <ReactDataGrid
              rowKey="Name"
              {...this.props}
              onGridSort={this.handleGridSort}
              rowGetter={this.rowGetter}
              rowsCount={this.getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

export default DisplayDataGrid;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/DisplayDataGrid.jsx